import React from "react"
import { Outlet } from "react-router-dom"

import Navbar from "../components/common/Navbar"
import Footer from "../components/common/Footer"
import ScrollToTop from "../components/common/ScrollToTop"

export default function MainLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Scroll reset on route change */}
      <ScrollToTop />

      {/* Navbar */}
      <Navbar />

      {/* Page Content */}
      <main className="flex-1 pt-[90px]">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}